/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ApplicationDelay = {
    Normal: 'NORMAL',
    High: 'HIGH'
} as const;
export type ApplicationDelay = typeof ApplicationDelay[keyof typeof ApplicationDelay];


export function instanceOfApplicationDelay(value: any): boolean {
    for (const key in ApplicationDelay) {
        if (Object.prototype.hasOwnProperty.call(ApplicationDelay, key)) {
            // @ts-ignore
            if (ApplicationDelay[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApplicationDelayFromJSON(json: any): ApplicationDelay {
    return ApplicationDelayFromJSONTyped(json, false);
}

export function ApplicationDelayFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationDelay {
    return json as ApplicationDelay;
}

export function ApplicationDelayToJSON(value?: ApplicationDelay | null): any {
    return value as any;
}

